import axios from "axios";

export const client = axios.create({
  baseURL: "/api",
  timeout: 15 * 1000,
  withCredentials: true,
});
